import { render, staticRenderFns } from "./profileImageView.vue?vue&type=template&id=3f064764&scoped=true&"
import script from "./profileImageView.vue?vue&type=script&lang=js&"
export * from "./profileImageView.vue?vue&type=script&lang=js&"
import style0 from "./profileImageView.vue?vue&type=style&index=0&id=3f064764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f064764",
  null
  
)

export default component.exports